<template>
   <ExpensesIntro :expense-type="expenseType">
      <b-alert
         v-if="isRndig && hasPeriodsWithoutConfiguredProject"
         show
         variant="warning"
         class="mt-2"
      >
         Some study period{{ missingConfiguredPeriods.length > 1 ? 's' : '' }} ({{
            missingConfiguredPeriodLabels
         }}) have no configured project attached and are currently excluded from this page.
         Configure projects in
         <b-link :to="`/company/${companyId}/projects`">Business Components</b-link>.
      </b-alert>
      <CrossPeriodMessage :expense-type="expenseType" />
      <ProjectsTable />
      <SuppliesDeclarations v-if="expenseType === 'supplies'" />
      <CloudDeclarations v-if="expenseType === 'cloud'" />
      <ContractorsDeclarations v-if="expenseType === 'contractors'" />
      <ActivePeriodTable :expense-type="expenseType" />
   </ExpensesIntro>
</template>

<script>
import {mapGetters} from 'vuex';
import SuppliesDeclarations from './components/SuppliesDeclarations.vue';
import CloudDeclarations from './components/CloudDeclarations.vue';
import ActivePeriodTable from './components/ActivePeriodTable.vue';
import ExpensesIntro from './components/ExpensesIntro.vue';
import CrossPeriodMessage from './components/CrossPeriodMessage.vue';
import ContractorsDeclarations from './components/ContractorsDeclarations.vue';

export default {
   name: 'ExpensesTable',
   components: {
      ContractorsDeclarations,
      CrossPeriodMessage,
      ExpensesIntro,
      CloudDeclarations,
      ActivePeriodTable,
      SuppliesDeclarations,
   },
   props: {
      expenseType: {
         type: String,
         required: true,
         validator: (value) => ['cloud', 'supplies', 'contractors', 'employees'].includes(value),
      },
   },
   computed: {
      ...mapGetters({
         isRndig: 'isRndig',
         activeStudyPeriods: 'companies/activeStudyPeriods',
         projectsSupportedPeriodIds: 'projects/projectsSupportedPeriodIds',
      }),

      companyId() {
         return this.$route.params.id || this.$companyId;
      },

      hasPeriodsWithoutConfiguredProject() {
         return this.activeStudyPeriods.some(
            ({id}) => !this.projectsSupportedPeriodIds.includes(id)
         );
      },

      missingConfiguredPeriods() {
         return this.activeStudyPeriods.filter(
            ({id}) => !this.projectsSupportedPeriodIds.includes(id)
         );
      },

      missingConfiguredPeriodLabels() {
         return this.missingConfiguredPeriods.map(({label}) => label).join(', ');
      },
   },
};
</script>

<style lang="scss" scoped></style>
